import React from 'react';
import { Gradient } from '../Gradient';

const PdfFile = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M11.0079 6.34769H7.67419C6.75362 6.34769 6.00735 5.60142 6.00735 4.68085V1.34717M5.80957 9.69774C5.20711 9.01102 4.87584 8.28697 5.35832 8.0536C5.84787 7.81681 5.94082 8.6927 5.80957 9.69774ZM5.80957 9.69774C6.08539 10.0121 6.41805 10.3187 6.75549 10.5668M5.80957 9.69774C5.75861 10.088 5.67384 10.4977 5.56537 10.8693M6.75549 10.5668C7.44919 11.0768 8.16309 11.3396 8.44485 10.9149C8.76343 10.4349 7.81852 10.3807 6.75549 10.5668ZM6.75549 10.5668C6.35514 10.6369 5.93804 10.741 5.56537 10.8693M5.56537 10.8693C4.69679 11.1684 4.06952 11.5987 4.45812 12.0346C4.87015 12.4968 5.29268 11.8035 5.56537 10.8693ZM11.0079 6.20469V13.015C11.0079 13.9356 10.2616 14.6819 9.34103 14.6819H2.67368C1.75311 14.6819 1.00684 13.9356 1.00684 13.015V3.01401C1.00684 2.09344 1.75311 1.34717 2.67368 1.34717H6.15035C6.59242 1.34717 7.01639 1.52278 7.32898 1.83537L10.5197 5.02606C10.8323 5.33865 11.0079 5.76262 11.0079 6.20469Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'}
      strokeWidth="1" 
      strokeLinecap="round" 
      strokeLinejoin="round"/>
      <Gradient className={className} />
</svg>

  );
};

export default PdfFile;